let sliders = document.querySelectorAll('.splide:not(.custom-slider)')
let bannerSlider = document.querySelector('.js-splider-banner')

if((sliders && sliders.length > 0) || bannerSlider){
	(async () => {
		const spliders = await import('./sliders');
		spliders.default(sliders, { bannerSlider });
	})();
}